import React, { Fragment } from "react";
import { observer } from "mobx-react-lite";
import { selectorMapEditorStore } from "../../../../stores/MapEditorStore";
import { DynamicMapElementNPCModel } from "../../../../../shared/game/dynamicMapElements/DynamicMapElementNPCModel";
import { DynamicMapElementAreaTriggerModel } from "../../../../../shared/game/dynamicMapElements/DynamicMapElementAreaTriggerModel";
import { ActionMapViewerSelectorButtonFromElement } from "./ActionMapViewerSelectorButtonFromElement";
import { ActionMapViewerSelectorPopupContainer } from "./ActionMapViewerSelectorPopupContainer";
export const ActionMapViewerSelectorPopup = observer(({
  selectedMapElements,
  selectElement,
  canvasContainerRef
}) => {
  if (!selectorMapEditorStore.hasSelectedTile) return null;
  const {
    selectedInteractionTriggerTiles,
    selectedDynamicMapElements
  } = selectorMapEditorStore;
  return /*#__PURE__*/React.createElement(ActionMapViewerSelectorPopupContainer, {
    canvasContainerRef: canvasContainerRef
  }, selectedInteractionTriggerTiles.map(tileData => /*#__PURE__*/React.createElement(ActionMapViewerSelectorButtonFromElement, {
    key: tileData.$modelId,
    element: tileData,
    elementId: tileData.interactionTriggerData.$modelId,
    selectElement: selectElement,
    selectedMapElements: selectedMapElements
  })), selectedDynamicMapElements.map(element => {
    if (element instanceof DynamicMapElementAreaTriggerModel) {
      // Area triggers might be refered to either by $modelId or by id.
      // We'll leave it to ActionMapViewerSelectorButtonFromElement to decide
      // which one is in selectedMapElements - the other one won't be rendered.
      return /*#__PURE__*/React.createElement(Fragment, {
        key: element.$modelId
      }, /*#__PURE__*/React.createElement(ActionMapViewerSelectorButtonFromElement, {
        element: element,
        elementId: element.$modelId,
        selectElement: selectElement,
        selectedMapElements: selectedMapElements
      }), /*#__PURE__*/React.createElement(ActionMapViewerSelectorButtonFromElement, {
        element: element,
        elementId: element.id,
        selectElement: selectElement,
        selectedMapElements: selectedMapElements
      }));
    }

    let additionalElements = undefined;

    if (element instanceof DynamicMapElementNPCModel) {
      if (element.viewAreaTriggers.length > 0) {
        additionalElements = [];

        for (const viewAreaTrigger of element.viewAreaTriggers) {
          additionalElements.push( /*#__PURE__*/React.createElement(ActionMapViewerSelectorButtonFromElement, {
            key: viewAreaTrigger.$modelId,
            element: viewAreaTrigger,
            elementId: viewAreaTrigger.name,
            selectElement: selectElement,
            selectedMapElements: selectedMapElements
          }));
        }
      }
    }

    return /*#__PURE__*/React.createElement(Fragment, {
      key: element.$modelId
    }, /*#__PURE__*/React.createElement(ActionMapViewerSelectorButtonFromElement, {
      element: element,
      elementId: element.$modelId,
      selectElement: selectElement,
      selectedMapElements: selectedMapElements
    }), additionalElements);
  }));
});